import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data(){
      // we aren't using every input in the <form> here - only the ones we need interaction with
      // when we submit the form, we will just allow the form to work naturally
      return {
        firingPrivileges: 0,
        approved: 0,
        approvalComments: ""
      }
    },
    watch: {
      firingPrivileges(){
        if(this.firingPrivileges){
          this.approved = 0
          this.approvalComments = "Nominee has hiring and firing privileges."
        } else {
          this.approvalComments = ""
        }
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.rose-nominee-approval-form')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}